import React from 'react'
import WbSunnyIcon from '@mui/icons-material/WbSunnyRounded'
import { Tooltip } from '@mui/material'
import WeatherPanel from '../weather/WeatherPanel'
import { HeaderIconButton } from './HeaderIconButton'

export interface WeatherButtonProps {
  stationId: number | null
  stationName: string | null
  stationTimezone: string | null
}

const WeatherButton: React.FC<WeatherButtonProps> = ({ stationId, stationName, stationTimezone }) => {
  const [open, setOpen] = React.useState(false)
  const triggerRef = React.useRef<HTMLButtonElement | null>(null)
  const dialogId = React.useId()

  const handleOpen = React.useCallback(() => {
    if (!stationId) {
      return
    }
    setOpen(true)
  }, [stationId])

  const handleClose = React.useCallback(() => {
    setOpen(false)
    window.setTimeout(() => {
      triggerRef.current?.focus()
    }, 0)
  }, [])

  React.useEffect(() => {
    if (!stationId && open) {
      setOpen(false)
    }
  }, [open, stationId])

  const tooltipTitle = stationId
    ? 'Open weather assistant'
    : 'Weather unavailable — select a station'

  return (
    <>
      <Tooltip title={tooltipTitle} enterDelay={200}>
        <span>
          <HeaderIconButton
            ref={triggerRef}
            onClick={handleOpen}
            aria-label="Open weather assistant"
            aria-haspopup="dialog"
            aria-expanded={open ? 'true' : undefined}
            aria-controls={open ? dialogId : undefined}
            disabled={!stationId}
            type="button"
          >
            <WbSunnyIcon />
          </HeaderIconButton>
        </span>
      </Tooltip>
      <WeatherPanel
        open={open}
        onClose={handleClose}
        stationId={stationId}
        stationName={stationName}
        stationTimezone={stationTimezone}
        dialogId={dialogId}
      />
    </>
  )
}

export default WeatherButton
